/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Chemistry14Inputs */

const en__field_enum_study_chemistry14 = /** @type {(inputs: _Field_Enum_Study_Chemistry14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemistry`)
};

const de__field_enum_study_chemistry14 = /** @type {(inputs: _Field_Enum_Study_Chemistry14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemie`)
};

/**
* | output |
* | --- |
* | "Chemistry" |
*
* @param {_Field_Enum_Study_Chemistry14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_chemistry14 = /** @type {((inputs?: _Field_Enum_Study_Chemistry14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Chemistry14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_chemistry14(inputs)
	return de__field_enum_study_chemistry14(inputs)
});
export { _field_enum_study_chemistry14 as "_field_enum_STUDY_CHEMISTRY" }